export default __webpack_public_path__ + "static/room-placeholder-3e6a9a623ecadfee16d934adab133c74.jpg";